
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/why-emenu",
      function () {
        return require("private-next-pages/why-emenu.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/why-emenu"])
      });
    }
  